import type { Doc } from '~convex/_generated/dataModel'

/**
 * Project enum values and view types, extracted into a leaf module so route
 * `validateSearch` decoders (which stay in the eager route-config chunk)
 * don't drag `lib/projects.ts` — and with it zod — into the initial bundle.
 * The lazy `MessageDescriptor` label maps for these enums stay in
 * `lib/projects.ts`, which only the app surface renders.
 */

/** A view value for the projects page — the toggle between table and kanban. */
export type ProjectView = 'list' | 'board' | 'timeline'
export const PROJECT_VIEWS: ProjectView[] = ['list', 'board', 'timeline']

export type ProjectType = NonNullable<Doc<'projects'>['projectType']>
export type UsageType = NonNullable<Doc<'projects'>['usageType']>

export const TYPE_ORDER: ProjectType[] = [
  'new_construction',
  'renovation',
  'expansion',
  'regularization',
  'interior_design',
  'consulting',
  'landscaping',
  'urban_planning',
]

export const USAGE_ORDER: UsageType[] = [
  'residential',
  'commercial',
  'corporate',
  'industrial',
  'institutional',
  'mixed',
  'rural',
]
